<template>
  <div class="check-container">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      label-position="top"
      size="small"
    >
      <div class="person-info clearfix" style="margin-bottom: 20px">
        <h3>{{ $t("app.personalInfo") }}</h3>
        <el-divider></el-divider>
        <el-form-item
          :label="$t('app.statement')"
          prop="declare"
          ref="declare"
        >
          <el-checkbox class="phoneCheckbox" :style="!$store.state.Config.device?{whiteSpace: 'pre-wrap', display: 'block'}
          :{display: 'block'}" v-model="ruleForm.declare" width="100px">{{
            $t("app.checkoutView.statement")
          }}</el-checkbox>
        </el-form-item>
        <el-col  :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item
            :label="$t('app.studentIDNo')"
            prop="studentCode"
            ref="studentCode"
          >
            <el-input
              v-model="ruleForm.studentCode"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item
            :label="$t('app.nameEnglish')"
            prop="nameEnglish"
            ref="nameEnglish"
          >
            <el-input
              v-model="ruleForm.nameEnglish"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('app.chineseName')">
            <el-input v-model="ruleForm.nameChina" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('app.contactNo')" prop="tel" ref="tel">
            <el-input v-model="ruleForm.tel" disabled></el-input>
          </el-form-item>
        </el-col>
      </div>
      <div class="application-form">
        <h3>{{ $t("app.residentialInformation") }}</h3>
        <el-divider></el-divider>
        <el-form-item :label="$t('app.hostelRoomNo')" prop="room" ref="room">
          <el-input v-model="ruleForm.room" disabled></el-input>
        </el-form-item>
        <el-form-item
          prop="date"
          :label="$t('app.expectedCheckoutDate')"
          ref="date"
        >
          <el-date-picker
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="$t('app.validation.date')"
            v-model="ruleForm.date"
            style="width: 200px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          prop="time"
          :label="$t('app.expectedCheckoutTime')"
          ref="time"
        >
          <el-time-picker
            :placeholder="$t('app.validation.time')"
            value-format="HH:mm"
            format="HH:mm"
            v-model="ruleForm.time"
            style="width: 200px"
          ></el-time-picker>
        </el-form-item>
        <el-form-item
          :label="$t('app.reasonForLateCheckout')"
          v-if="dateDisable"
          prop="reason"
          class="customRequired"
        >
          <el-input type="textarea" v-model="ruleForm.reason"></el-input>
        </el-form-item>
        <el-form-item
          v-if="dateDisable"
          :label="$t('app.uploadSupportingDocument')"
        >
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            :on-error="handleErr"
            :before-upload="beforeUpload"
            :before-remove="beforeRemove"
            multiple
            :file-list="fileList"
          >
            <el-button size="small" type="primary">點擊上傳</el-button>
            <div slot="tip" class="el-upload__tip">不超過2mb</div>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('app.remarks')">
          <el-input
            type="textarea"
            autosize
            v-model="remarks"
            disabled
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            :loading="submitting"
            @click="submitForm('ruleForm')"
            >{{ $t("app.submit") }}</el-button
          >
          <el-button size="small" @click="reload()">{{
            $t("app.reset")
          }}</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>
import { url } from "@/utils/request";
import { submit, getInfo, isLate } from "@/api/checkOut";
export default {
  inject: ["reload"],
  data() {
    var declareCheck = (rule, value, callback) => {
      const that = this;
      if (!value) {
        callback(new Error(that.$t("app.validation.declare")));
      } else {
        callback();
      }
    };
    var reasonCheck = (rule, value, callback) => {
      if (this.dateDisable && !value) {
        callback(new Error(this.$t("app.validation.reasonOfCheckOut")));
      } else {
        callback();
      }
    };
    return {
      uploadUrl: url + "/CheckOutApplication/UploadFile",
      remarks:
        this.$t("app.checkoutView.remarksA") +
        "\n" +
        this.$t("app.checkoutView.remarksB") +
        "\n" +
        this.$t("app.checkoutView.remarksC") +
        "\n" +
        this.$t("app.checkoutView.remarksD"),
      port: [],
      msg: "",
      dateDisable: false,
      submitting: false,
      fileList: [],
      ruleForm: {
        declare: "",
        studentCode: "",
        nameEnglish: "",
        nameChina: "",
        tel: "",
        room: "",
        date: "",
        reason: "",
        time: "",
      },
      rules: {
        declare: [{ required: true, validator: declareCheck, trigger: "blur" }],
        studentCode: [
          {
            required: true,
            message: this.$t("app.validation.applyCode"),
            trigger: "blur",
          },
        ],
        tel: [
          {
            required: true,
            message: this.$t("app.validation.tel"),
            trigger: "blur",
          },
        ],
        room: [
          {
            required: true,
            message: this.$t("app.validation.room"),
            trigger: "blur",
          },
        ],
        date: [
          {
            required: true,
            message: this.$t("app.validation.date"),
            trigger: "change",
          },
        ],
        time: [
          {
            required: true,
            message: this.$t("app.validation.date"),
            trigger: "change",
          },
        ],
        reason: [
          {
            required: false,
            validator: reasonCheck,
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    getInfo().then((res) => {
      this.ruleForm.studentCode = res.data.StudentCode;
      this.ruleForm.nameEnglish = res.data.EnglishName;
      this.ruleForm.nameChina = res.data.ChineseName;
      this.ruleForm.tel = res.data.ContactMobile;
      this.ruleForm.room = res.data.RoomIndex;
    });
  },
  watch: {
    "ruleForm.date": {
      handler(val) {
        this.setDateDisable(val);
      },
      immediate: true,
    },
  },
  methods: {
    setDateDisable(date) {
      isLate({ expectedCheckOutDate: date }).then((res) => {
        this.dateDisable = res.data;
      });
    },
    handleSuccess(event, file, fileList) {
      this.fileList = fileList.map((i) => {
        return {
          name: i.name,
          url: i.url || i.response.data.Url,
        };
      });
    },
    handleRemove(file, fileList) {
      this.fileList = fileList.map((i) => {
        return {
          name: i.name,
          url: i.url || i.response.data.Url,
        };
      });
    },
    handleErr() {
      this.$message.error("上傳失敗，請重試");
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
        return false;
      }
    },
    beforeRemove(file, fileList) {
      console.log(fileList);
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    submitForm(formName) {
      const that = this;
      this.$refs[formName].validate((valid, object) => {
        if (valid) {
          that.submitting = true;
          submit({
            StudentCode: this.ruleForm.studentCode,
            ExpectedCheckOutDate: this.ruleForm.date,
            ReasonForLateCheckOut: this.ruleForm.reason,
            UploadSupportingDocument: this.fileList.map((_) => {
              return {
                Name: _.name,
                Url: _.url,
              };
            }),
            ExpectedCheckOutTime: this.ruleForm.time,
          })
            .then(() => {
              this.$message({
                message: this.$t("app.opeSuccess"),
                type: "success",
              });
              that.submitting = false;
              this.reload();
              this.$router.push("/oldStu");
            })
            .catch(() => {
              that.submitting = false;
            });
        } else {
          for (let i in object) {
            let dom = this.$refs[i];
            if (Object.prototype.toString.call(dom) !== "[object Object]") {
              //这里是针对遍历的情况（多个输入框），取值为数组
              dom = dom[0];
            }
            dom.$el.scrollIntoView({
              //滚动到指定节点
              block: "center", //值有start,center,end，nearest，当前显示在视图区域中间
              behavior: "smooth", //值有auto、instant,smooth，缓动动画（当前是慢速的）
            });
            return false;
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.check-container {
  overflow: auto;
  .person-info,
  .application-form,
  .date-content {
    background-color: #fff;
    padding: 15px;
    border: solid 1px #ccc;
    border-radius:5px ;
  }
}
</style>
<style lang="scss" scoped>
.check-container {
  .person-info,
  .application-form,
  .date-content {
    .el-form-item__content {
      padding: 0 15px;
    }
    .el-input {
      width: 300px;
    }
    .el-radio {
      margin-bottom: 6px;
    }
  }
}
.customRequired {
  label:before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}
.phoneCheckbox {
  ::v-deep .el-checkbox__label {
    display: inline;
  }
}

</style>
